import { InjectionToken } from '@angular/core';

/**
 * Optional injection token that analytics-logging-lib uses to obtain the
 * current user's orgId at the time an error is logged.
 *
 * Apps that want client.error events to carry actor.orgId should provide
 * this token in their app.config.ts:
 *
 * ```ts
 * {
 *   provide: ANALYTICS_ORG_ID_PROVIDER,
 *   useFactory: () => {
 *     const auth = inject(AuthService);
 *     return () => auth.currentUser()?.orgId;
 *   }
 * }
 * ```
 *
 * If not provided, orgId will be omitted from client events (the backend will
 * still resolve it from the auth token where possible).
 */
export const ANALYTICS_ORG_ID_PROVIDER = new InjectionToken<() => string | undefined>(
  'ANALYTICS_ORG_ID_PROVIDER',
  { providedIn: 'root', factory: () => () => undefined }
);
